// import axios from 'axios';
// import router from '../router/index'
// import {getToken,removeToken ,removeInfo } from "./auth";
// import { Toast } from 'vant';

// let http = axios.create({
// 	timeout:1000,
//     baseURL: process.env.NODE_ENV=="production"?"http://222.73.134.202:8091":"http://222.73.134.202:8091",
// 	// 
//     withCredentials: true, //设置跨域，不需要设置为false即可
// });
// // 添加请求拦截器，在参数中加token
// http.interceptors.request.use(
//     config => {
//         if (getToken()) {
//             // 注意：config.method 的判断值必须是小写的post和get
//             config.headers['Authorization'] ='Bearer '+ getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
//         } else {
//             router.push('/login')
//         }
//         return config;
//     },
//     error => {
//        return Promise.reject(error)
//     }
// )

// http.interceptors.response.use(
//     response => {
//         // if (response.data.code=="未授权") {
//         //     router.push({
//         //         path: '/login',
//         //     })
//         // }
//         return response;
//     },
//     error => {
// 		if(!error.message.includes('timeout')){
// 			if (error.response.data.code=="未授权") {
// 			    router.push({
// 			        path: '/login',
// 			    })
// 				removeToken()
// 				removeInfo()
// 			}
// 			return Promise.reject(error.response.data)
// 		}else{
// 			Toast('请求超时，请稍后再试')
// 			return Promise.reject(error);    
// 		}
		
		
		
		
// 		// if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
// 		//         // reject这个错误信息
// 		// }
// 		// Toast('网络连接失败，请稍后再试')
			
//         // 
// });

// export default http;

import axios from 'axios';
import router from '../router/index'
import {getToken,removeToken ,removeInfo } from "./auth";

let http = axios.create({
    // baseURL: process.env.NODE_ENV=="production"?"http://222.73.134.202:8091":"http://222.73.134.202:8091",
    // baseURL: process.env.NODE_ENV=="production"?"http://192.168.1.122:8091":"http://192.168.1.122:8091",
	baseURL:process.env.VUE_APP_BASE_API,
	// "http://172.16.16.15:8091/",
	// "http://222.73.134.202:8091",
	// "http://192.168.1.131:8091/",
	// "http://106.15.237.145:9095",
	// 
    withCredentials: true, //设置跨域，不需要设置为false即可
});
// 添加请求拦截器，在参数中加token
http.interceptors.request.use(
    config => {
        console.log(router.history.current.path)
        if (getToken()) {
            // 注意：config.method 的判断值必须是小写的post和get
            config.headers['Authorization'] ='Bearer '+ getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        } else {
			if(router.history.current.path!='/report' && router.history.current.path!='/engineering_institute'&& router.history.current.path!='/sdeclare'){
				router.push('/login')
			}
        }
        return config;
    },
    error => {
       // return Promise.reject(error)
    }
)

http.interceptors.response.use(
    response => {
        if (response.data.code=="未授权") {
            router.push({
                path: '/login',
            })
        }
        return response;
    },
    error => {
		// console.log(error)
		if (error.response.data.code=="未授权") {
			// Toast.fail('账号异常，请重新登录')
			setTimeout(()=>{
				router.push({
				    path: '/login',
				})
			},1000)
			removeToken()
			removeInfo()
		}
        // return Promise.reject(error.response.data)
});

export default http;

